import { NgModule, ModuleWithProviders } from "@angular/core";
import { HttpClientModule, HTTP_INTERCEPTORS } from "@angular/common/http";

import { LosAuthService } from "./los-auth.service";
import { LosAuthGuardService } from "./los-auth-guard.service";
import { LosAuthInterceptor } from "./los-auth.interceptor";

@NgModule({
    imports: [HttpClientModule],
    exports: [HttpClientModule]
})
export class LosAuthModule {
    public static forRoot(): ModuleWithProviders {
        return {
            ngModule: LosAuthModule,
            providers: [
                LosAuthService,
                LosAuthGuardService,
                {
                    provide: HTTP_INTERCEPTORS,
                    useClass: LosAuthInterceptor,
                    multi: true
                }
            ]
        };
    }
}